import React, { useEffect, useState } from 'react';
import InputField from '../../../../components/Input';
import { ButtonBackForm, ButtonNextForm } from '../../../home/styledMui';
import { stepsData } from '../../stepsData';
import { Props } from './models';
import { ButtonWrapper, GridCenter, TittleSection } from '../../styled';
import { sendEvent } from '../../../../utils/functions';

const PaymentDataInformation: React.FC<Props> = ({
  activeStep,
  handleSubmit,
  completedStep,
  resetForm,
  handleBack,
  registerIdLog,
  registerEmailLog
}) => {
  const [paymentDataInformation, setpaymentDataInformation] = useState({
    fiscalAddress: '',
    zipCode: '',
    bankName: '',
    accountNumber: '',
    swiftCode: '',
    bankAddress: '',
  });

  const configSendEvent = (pageError: string) => {
    sendEvent("payment_information_accounting_data", 
      "user_event_error_form_international", pageError, registerIdLog || '', registerEmailLog || '');
  };

  const handleChange = (ev: any) => {
    try {
      const { name, value } = ev.target;
      setpaymentDataInformation({
        ...paymentDataInformation,
        [name]: value
      })
    }
    catch (error) {
      const pageError = `handleChange: ${error}`;
      configSendEvent(pageError);
    }
  };

  const handleChangeNumber = (ev: any) => {
    try {
      const { name, value } = ev.target;
      setpaymentDataInformation({
        ...paymentDataInformation,
        [name]: value
      })
    }
    catch (error) {
      const pageError = `handleChangeNumber: ${error}`;
      configSendEvent(pageError);
    }
  };

  const cleanDataForm = () => {
    setpaymentDataInformation({
      fiscalAddress: '',
      zipCode: '',
      bankName: '',
      accountNumber: '',
      swiftCode: '',
      bankAddress: '',
    })
  };

  const handleSubmitForm = (ev: any) => {
    try {
      ev.preventDefault();
      handleSubmit && handleSubmit(paymentDataInformation, "accountingData");
      completedStep && completedStep(true, 'paymentDataInformation');
    }
    catch (error) {
      const pageError = `handleSubmitForm: ${error}`;
      configSendEvent(pageError);
    }
  };

  useEffect(() => {
    resetForm && cleanDataForm();
  }, [resetForm]);
  return (
    <>
      {stepsData[2].id === activeStep && (
        <form onSubmit={handleSubmitForm}>
          <TittleSection>
            <h2>Payment Information</h2>
            <span>Accounting data</span>
          </TittleSection>
          <GridCenter item xs={12}>
            <InputField
              label="Fiscal Address"
              placeholder="Ex.: Longgang qu nanwan jiedao pingji dadao 1 hao"
              disabled={false}
              name="fiscalAddress"
              value={paymentDataInformation.fiscalAddress}
              onChange={handleChange}
            />
          </GridCenter>
          <GridCenter item xs={12}>
            <InputField
              label="Zip code"
              placeholder="Ex.: 518000"
              disabled={false}
              name="zipCode"
              value={paymentDataInformation.zipCode || ''}
              onChange={handleChangeNumber}
              type="number"
            />
          </GridCenter>
          <GridCenter item xs={12}>
            <InputField
              label="Bank name"
              placeholder="Ex.: Bank of China (Hong Kong) Limited"
              disabled={false}
              name="bankName"
              value={paymentDataInformation.bankName}
              onChange={handleChange}
            />
          </GridCenter>
          <GridCenter item xs={12}>
            <InputField
              label="Account number"
              placeholder="Ex.: 601-92-14471-8 (USD)"
              disabled={false}
              name="accountNumber"
              value={paymentDataInformation.accountNumber}
              onChange={handleChange}
            />
          </GridCenter>
          <GridCenter item xs={12}>
            <InputField
              label="Swift code"
              placeholder="Ex.: BKCHHKHHXXX"
              disabled={false}
              name="swiftCode"
              value={paymentDataInformation.swiftCode}
              onChange={handleChange}
            />
          </GridCenter>
          <GridCenter item xs={12}>
            <InputField
              label="Bank Address"
              placeholder="Ex.: Flat /Rm 14 BLK A 7/F Sun Fung Centre 88 "
              disabled={false}
              name="bankAddress"
              value={paymentDataInformation.bankAddress}
              onChange={handleChange}
            />
          </GridCenter>
          <ButtonWrapper>
            <ButtonBackForm fullWidth onClick={() => handleBack()} variant="contained">
              Back
            </ButtonBackForm>
            <ButtonNextForm fullWidth type='submit' variant="contained">
              Continue
            </ButtonNextForm>
          </ButtonWrapper>
        </form>
      )}
    </>
  )
};

export default PaymentDataInformation;